import React, { useState, useEffect, useCallback, useMemo } from "react";
import Header from "../components/header";
import OrangeButton from "../components/common/orangeButton";
import BabyImage from "../components/main/baby";
import LogoutImage from "../images/baby/logout.png";
import AboutBaby from "../images/main/baby.png";
import AboutMother from "../images/main/mother.png";
import AboutFather from "../images/main/father.png";
import ChatbotImage from "../images/main/chatbot.png";
import BabyBorn from "../images/main/39주.png";
import BottomSheet from "../components/common/BottomSheet";
import Toast from "../components/common/toast";
import useAuthStore from "../store/authStore";
import twinsBabyData from "../data/twinsBabyData";
import singleBabyData from "../data/singleBabyData";
import postBirthData from "../data/postBirthData";
import userHooks from "../hooks/userHooks";
import BabyCongratsModal from "../components/main/BabyCongratsModal";
import { calculatePregnancyInfo, formatDate } from "../utils/pregnancyUtils";
import singleBabyCongratsData from "../data/singleBabyCongratsData";
import twinsBabyCongratsData from "../data/twinsBabyCongratsData";

const Main = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const userInfo = useAuthStore((state) => state.userInfo);

  const [isBabyBottomSheetOpen, setIsBabyBottomSheetOpen] = useState(false);
  const [isMomBottomSheetOpen, setIsMomBottomSheetOpen] = useState(false);
  const [isDadBottomSheetOpen, setIsDadBottomSheetOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [isCongratsModalOpen, setIsCongratsModalOpen] = useState(false);

  const showErrorToast = useCallback((message) => {
    setToastMessage(message);
    setShowToast(true);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pregnancyInfo = useMemo(
    () => calculatePregnancyInfo(userInfo?.baby?.[0]?.baby_birth, showErrorToast),
    [userInfo?.baby, showErrorToast]
  );

  // 임신 중 새로운 주차 축하 모달 표시 
  useEffect(() => {
    if (isAuthenticated && !pregnancyInfo.isPostpartum && pregnancyInfo.week >= 0) {
      const lastWeek = localStorage.getItem('lastPregnancyCelebrationWeek');
      if (!lastWeek || parseInt(lastWeek) !== pregnancyInfo.week) {
        setIsCongratsModalOpen(true);
        localStorage.setItem('lastPregnancyCelebrationWeek', pregnancyInfo.week.toString());
      }
    }
  }, [isAuthenticated, pregnancyInfo.isPostpartum, pregnancyInfo.week]);

  const handleCloseBabySheet = useCallback(() => {
    setIsBabyBottomSheetOpen(false);
  }, []);

  const handleCloseMomSheet = useCallback(() => {
    setIsMomBottomSheetOpen(false);
  }, []);

  const handleCloseDadSheet = useCallback(() => {
    setIsDadBottomSheetOpen(false);
  }, []);

  const handleOpenBabySheet = useCallback(() => {
    setIsBabyBottomSheetOpen(true);
  }, []);

  const handleOpenMomSheet = useCallback(() => {
    setIsMomBottomSheetOpen(true);
  }, []);

  const handleOpenDadSheet = useCallback(() => {
    setIsDadBottomSheetOpen(true);
  }, []);

  const MoveToDaium = useCallback(() => {
    window.location.href = "https://daiumhomepage.dplanit.co.kr/";
  }, []);

  const MoveToQnA = useCallback(() => {
    window.open("http://pf.kakao.com/_xfDPbs", "_blank", "noopener,noreferrer");
  }, []);

  const handleKakaoLoginSuccess = useCallback(async () => {
    try {
      const res = await window.Kakao.API.request({
        url: "/v2/user/me",
      });

      const kakaoAccount = res.kakao_account;
      if (!kakaoAccount) {
        throw new Error("카카오 계정 정보를 가져올 수 없습니다.");
      }

      const loginResponse = await userHooks.signinHooks({
        private_id: `${res.id}`,
      });

      if (loginResponse.status) {
        const authStore = useAuthStore.getState();
        authStore.setAuth(loginResponse);

        if (loginResponse.isSignedUp && loginResponse.baby.length > 0) {
          window.location.replace("/");
        } else {
          window.location.replace("/authentication");
        }
      } else {
        // 회원가입 처리
        const userData = {
          private_id: `${res.id}`,
          user_name: kakaoAccount.profile?.nickname || "",
          message_allow: false,
          gender: kakaoAccount.gender === "female" ? "0" : "1",
          hp: "",
          private_consent: true,
          marketing_consent: true,
          birth: kakaoAccount.birthday || "",
        };

        const signupResponse = await userHooks.signupHooks(userData);

        if (signupResponse.status) {
          const authStore = useAuthStore.getState();
          authStore.setAuth(signupResponse);
          window.location.replace("/authentication");
        } else {
          if (signupResponse.message === "duplicated") {
            console.log("이미 가입된 회원입니다. 로그인을 재시도합니다.");

            const retryLoginResponse = await userHooks.signinHooks({
              private_id: `${res.id}`,
            });

            if (retryLoginResponse.status) {
              const authStore = useAuthStore.getState();
              authStore.setAuth(retryLoginResponse);

              if (
                retryLoginResponse.isSignedUp &&
                retryLoginResponse.baby.length > 0
              ) {
                window.location.replace("/");
              } else {
                window.location.replace("/authentication");
              }
            } else {
              throw new Error("로그인에 실패했습니다.");
            }
          } else {
            throw new Error(
              signupResponse.message || "회원가입에 실패했습니다."
            );
          }
        }
      }
    } catch (error) {
      console.error("카카오 사용자 정보 처리 실패:", error);
      alert("사용자 정보 처리 중 오류가 발생했습니다.");
    }
  }, []);

  const KakaoLogin = useCallback(async () => {
    const redirectLogin = () => {
      const currentUrl = window.location.origin;
      const redirectUri = `${currentUrl}/kakao/callback`;

      localStorage.setItem("kakao_login_redirect", window.location.pathname);

      window.Kakao.Auth.authorize({
        redirectUri: redirectUri,
        scope: "profile_nickname,profile_image,account_email,birthday",
        state: "login_state",
      });
    };

    try {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

      console.log(
        `환경 감지: ${isMobile ? "Mobile" : "Desktop"} - 자동 로그인 시도`
      );

      window.Kakao.Auth.login({
        scope: "profile_nickname, profile_image, account_email, birthday",
        throughTalk: true,
        persistAccessToken: true,
        success: async () => {
          console.log("✅ 카카오톡 앱 자동 로그인 성공");
          await handleKakaoLoginSuccess();
        },
        fail: async (error) => {
          console.log("⚠️ 카카오톡 앱 로그인 실패 또는 불가능:", error);

          if (isMobile) {
            console.log("📱 모바일 - 리다이렉트 방식으로 진행");

            setTimeout(() => {
              redirectLogin();
            }, 500);
          } else {
            console.log("💻 데스크톱 - 브라우저 팝업 방식으로 진행");

            window.Kakao.Auth.login({
              scope: "profile_nickname, profile_image, account_email, birthday",
              throughTalk: false,
              persistAccessToken: true,
              success: async () => {
                console.log("✅ 데스크톱 브라우저 로그인 성공");
                await handleKakaoLoginSuccess();
              },
              fail: (browserError) => {
                console.error("❌ 브라우저 로그인도 실패:", browserError);
                alert(
                  "로그인에 실패했습니다. 페이지를 새로고침 후 다시 시도해주세요."
                );
              },
            });
          }
        },
      });
    } catch (error) {
      console.error("로그인 프로세스 실패:", error);
      alert("로그인 중 오류가 발생했습니다.");
    }
  }, [handleKakaoLoginSuccess]);

  useEffect(() => {
    if (!document.getElementById("kakao-sdk")) {
      const script = document.createElement("script");
      script.id = "kakao-sdk";
      script.src = "https://developers.kakao.com/sdk/js/kakao.js";
      script.async = true;
      script.onload = () => {
        const KAKAO_KEY = process.env.REACT_APP_KAKAO_JAVASCRIPT_KEY;

        if (!window.Kakao.isInitialized()) {
          window.Kakao.init(KAKAO_KEY);
        }
      };
      document.head.appendChild(script);
    }

    return () => {
      const script = document.getElementById("kakao-sdk");
      if (script) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const getCurrentWeekData = () => {
    // 출산 후인 경우 postBirthData에서 일차별 데이터 가져오기
    if (pregnancyInfo.isPostpartum) {
      const daysSinceBirth = pregnancyInfo.daysSinceBirth || 1;

      // 정확한 일차 데이터가 있는지 먼저 확인
      const exactDayData = postBirthData.datas.find(
        (data) => data.day === daysSinceBirth
      );

      if (exactDayData) {
        return exactDayData;
      }

      // 정확한 일차 데이터가 없다면, 해당 일차보다 작거나 같은 일차 중 가장 큰 일차 데이터 찾기
      const availableDays = postBirthData.datas
        .filter((data) => data.day <= daysSinceBirth)
        .sort((a, b) => b.day - a.day); // 내림차순 정렬

      // 조건에 맞는 데이터가 있으면 첫 번째(가장 큰 일차) 반환
      if (availableDays.length > 0) {
        return availableDays[0];
      }

      // 그래도 없으면 첫 번째 데이터(1일차) 반환
      return postBirthData.datas[0];
    }

    // 임신 중인 경우
    let week = pregnancyInfo.week;
    const babyType = userInfo?.baby?.[0]?.baby_type;
    const data =
      babyType === "TWIN" || babyType === "twins"
        ? twinsBabyData
        : singleBabyData;

    // 쌍둥이의 경우 1, 2주차 데이터가 없으므로 0주차 데이터 사용
    if ((babyType === "TWIN" || babyType === "twins") && (week === 1 || week === 2)) {
      week = 0;
    }

    return (
      data.datas.find((data) => data.week === week) ||
      data.datas[data.datas.length - 1]
    );
  };

  const currentWeekData = getCurrentWeekData();

  const getCongratsData = (week, babyType) => {
    const data = babyType === 'TWIN' || babyType === 'twins' 
      ? twinsBabyCongratsData 
      : singleBabyCongratsData;
    
    const congratsData = data[week] || data[0];
    return congratsData?.subtext || "축하합니다!";  
  };

  return (
    <>
      <div
        className="flex flex-col bg-white pt-[3.125rem] md:pt-[4.375rem]"
        style={{ 
          minHeight: "calc(var(--vh, 1vh) * 100)",
          paddingBottom: "max(1.875rem, env(safe-area-inset-bottom))"
        }}
      >
        {isAuthenticated ? (
          <>
            <Header selectedMenu={0} />
            <div className="flex flex-col items-center">
              <div className="block w-[calc(100%-2.875rem)] mx-auto pt-[1.875rem] md:pt-[2.125rem] max-w-[37.5rem]">
                <div className="relative h-0 top-0 left-1 text-lg md:text-[1.625rem] text-[#474747]">
                  {pregnancyInfo.remainingDays > 0 ? (
                    <>
                      {pregnancyInfo.week}주{" "}
                      {pregnancyInfo.day > 0 ? `${pregnancyInfo.day}일차` : "0일차"}
                    </>
                  ) : (
                    <>출산 {pregnancyInfo.daysSinceBirth}일차</>
                  )}
                </div>
                <div className="flex justify-center relative">
                  {pregnancyInfo.remainingDays > 0 ? (
                    <BabyImage
                      babytype={userInfo?.baby?.[0]?.baby_type}
                      babyweek={pregnancyInfo.week}
                    />
                  ) : (
                    <img
                      src={BabyBorn}
                      alt="태어난 아기 모습"
                      className="w-[270px] md:w-[25rem]"
                    />
                  )}
                  <button
                    onClick={MoveToDaium}
                    className="absolute z-10 -bottom-[3.575rem] md:-bottom-[5.575rem] -left-4 md:-left-5 w-[11.6875rem] md:w-[15.9375rem]"
                  >
                    <img
                      src={ChatbotImage}
                      alt="챗봇 상담"
                      className="w-full"
                    />
                  </button>
                </div>
              </div>
              <div className="flex w-full justify-end mx-auto max-w-[40.625rem] pr-[1.875rem] relative">
                <div className="w-full text-right text-[1.5rem] md:text-[1.625rem] mt-[1.75rem] mb-[0.8rem] leading-[1.8rem]">
                  {pregnancyInfo.remainingDays > 0 ? (
                    <>
                      <span className="font-semibold">
                        {userInfo?.baby?.[0]?.baby_name}
                      </span>{" "}
                      만나기까지
                      <br />
                      <span className="font-semibold text-[#fec009]">
                        {pregnancyInfo.remainingDays}일
                      </span>
                      <br />
                      남았어요!
                      <div className="mt-[0.5rem] text-[0.875rem] md:text-[1.125rem] text-[#B6B7B9] leading-[1.375rem]">
                        {formatDate(pregnancyInfo.dueDate)} 예정
                      </div>
                    </>
                  ) : (
                    <>
                      <div>출산을 축하드려요~</div>
                      <div>
                        드디어{" "}
                        <span className="font-semibold">
                          {userInfo?.baby?.[0]?.baby_name}
                        </span>
                        와
                        <br />
                        만났어요!
                      </div>
                      <div className="mt-[0.75rem] text-[0.875rem] md:text-[1.125rem] text-[#B6B7B9] leading-[1.375rem]">
                        {formatDate(pregnancyInfo.dueDate)} 출생
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="mt-[0.25rem] px-[0.5625rem] flex w-[calc(100%-2.875rem)] max-w-[25rem] items-center justify-between md:max-w-[28.125rem]">
                <button
                  className="w-[calc((100%-3.8125rem)/3)] max-w-[5.625rem] text-center md:max-w-[6.875rem]"
                  onClick={handleOpenBabySheet}
                >
                  <div className="mb-[0.9375rem] flex">
                    <img src={AboutBaby} alt="아기는" className="w-full" />
                  </div>
                  <div className="text-sm md:text-[1.125rem]">아기는?</div>
                </button>
                <button
                  className="w-[calc((100%-3.8125rem)/3)] max-w-[5.625rem] text-center md:max-w-[6.875rem]"
                  onClick={handleOpenMomSheet}
                >
                  <div className="mb-[0.9375rem] flex">
                    <img src={AboutMother} alt="엄마는" className="w-full" />
                  </div>
                  <div className="text-sm md:text-[1.125rem]">엄마는?</div>
                </button>
                <button
                  className="w-[calc((100%-3.8125rem)/3)] max-w-[5.625rem] text-center md:max-w-[6.875rem]"
                  onClick={handleOpenDadSheet}
                >
                  <div className="mb-[0.9375rem] flex">
                    <img src={AboutFather} alt="아빠는" className="w-full" />
                  </div>
                  <div className="text-sm md:text-[1.125rem]">아빠는?</div>
                </button>
              </div>
              {!userInfo?.message_allow && (
                <div 
                  className="w-full flex justify-center mt-[0.9375rem] md:mt-[1.875rem]"
                  style={{ marginBottom: "max(1.875rem, env(safe-area-inset-bottom))" }}
                >
                  <OrangeButton
                    text={"주수별 맞춤 알림톡 &\n1:1 전문가 상담 기능 추가"}
                    clickEvent={() =>
                      window.location.replace("/authentication")
                    }
                  />
                </div>
              )}
              {userInfo?.message_allow && (
                <div 
                  className="w-full flex justify-center mt-[0.9375rem] md:mt-[1.875rem]"
                  style={{ marginBottom: "max(1.875rem, env(safe-area-inset-bottom))" }}
                >
                  <OrangeButton
                    text={"1:1 전문가 상담"}
                    clickEvent={MoveToQnA}
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <Header selectedMenu={0} />
            <div className="flex flex-col items-center md:max-w-[75rem] md:mx-auto md:px-4 relative">
              <div className="flex justify-center w-[calc(100%)] mx-auto pt-10 max-w-[37.5rem] md:max-w-[50rem] relative">
                <img
                  src={LogoutImage}
                  alt="로그아웃 이미지"
                  className="w-[95%]"
                />
                <button
                  onClick={MoveToDaium}
                  className="absolute z-10 -bottom-[1.575rem] left-[0.9375rem] w-[11.6875rem] md:w-[15.9375rem]"
                >
                  <img src={ChatbotImage} alt="챗봇 상담" className="w-full" />
                </button>
              </div>
              <div className="mx-auto mt-[3.125rem] text-center text-[1.375rem] md:text-[1.625rem] text-[#FF931D] font-semibold">
                엄마! 나는 기다리고있어요.
              </div>
              <div className="mx-auto mt-[0.625rem] text-center text-[0.875rem] md:text-[1.125rem] leading-[1.375rem] md:leading-[1.625rem] text-[#040404]">
                "소중한 아기의 성장, 놓치지 마세요!
                <br />
                주수별 맞춤 알림톡과 1:1 전문가 상담으로
                <br />
                당신의 건강하고 행복한 임신을 함께합니다."
              </div>
            </div>
            <div 
              className="w-full z-10 flex justify-center bg-transparent mt-[2.5rem] md:mt-[1.875rem] mb-[3.125rem]"
              style={{ marginBottom: "max(3.125rem, calc(3.125rem + env(safe-area-inset-bottom)))" }}
            >
              <OrangeButton
                text={"카카오 로그인하고 맞춤 정보 받기"}
                clickEvent={KakaoLogin}
              />
            </div>
          </>
        )}
      </div>

      <Toast
        isOpen={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <BottomSheet
        isOpen={isBabyBottomSheetOpen}
        onClose={handleCloseBabySheet}
        className="rounded-t-[16px]"
        showCloseButton={false}
      >
        <div className="flex flex-col px-[4px]">
          <div className="flex flex-col items-center border-b border-[#E9EAEE] pb-[30px]">
            <h2 className="pt-[30px] text-[20px] font-semibold leading-[31px] mb-[10px] text-center whitespace-pre-line">
              {currentWeekData.baby.head.title}
            </h2>
            <p className="text-[16px] text-[#888888] text-center font-semibold">
              {currentWeekData.baby.head.discribed}
            </p>
            {currentWeekData.baby.head.size && (
              <span className="text-[14px] text-[#B6B7B9] text-center">
                {currentWeekData.baby.head.size}
              </span>
            )}
          </div>
          <div className="flex flex-col pt-[30px]">
            {currentWeekData.baby.body.map((item, index) => (
              <div key={index} className="mb-6">
                <h3 className="text-[17px] font-semibold mb-2">
                  {item.subTitle}
                </h3>
                <p className="text-[14px] whitespace-pre-line">
                  {item.discribed}
                </p>
              </div>
            ))}
          </div>
        </div>
      </BottomSheet>

      <BottomSheet
        isOpen={isMomBottomSheetOpen}
        onClose={handleCloseMomSheet}
        className="rounded-t-[16px]"
        showCloseButton={false}
      >
        <div className="flex flex-col px-[4px]">
          <div className="flex flex-col items-center border-b border-[#E9EAEE] pb-[30px]">
            <h2 className="pt-[30px] text-[20px] font-semibold leading-[31px] mb-[10px] text-center whitespace-pre-line">
              {currentWeekData.mom.head.title}
            </h2>
            <p className="text-[16px] text-[#888888] text-center font-semibold">
              {currentWeekData.mom.head.discribed}
            </p>
          </div>
          <div className="flex flex-col pt-[30px]">
            {currentWeekData.mom.body.map((item, index) => (
              <div key={index} className="mb-6">
                <h3 className="text-[17px] font-semibold mb-2">
                  {item.subTitle}
                </h3>
                <p className="text-[14px] whitespace-pre-line">
                  {item.discribed}
                </p>
              </div>
            ))}
          </div>
        </div>
      </BottomSheet>

      <BottomSheet
        isOpen={isDadBottomSheetOpen}
        onClose={handleCloseDadSheet}
        className="rounded-t-[16px]"
        showCloseButton={false}
      >
        <div className="flex flex-col px-[4px]">
          <div className="flex flex-col items-center border-b border-[#E9EAEE] pb-[30px]">
            <h2 className="pt-[30px] text-[20px] font-semibold leading-[31px] mb-[10px] text-center whitespace-pre-line">
              {currentWeekData.dad.head.title}
            </h2>
            <p className="text-[16px] text-[#888888] text-center font-semibold">
              {currentWeekData.dad.head.discribed}
            </p>
          </div>
          <div className="flex flex-col pt-[30px]">
            {currentWeekData.dad.body.map((item, index) => (
              <div key={index} className="mb-6">
                <h3 className="text-[17px] font-semibold mb-2">
                  {item.subTitle}
                </h3>
                <p className="text-[14px] whitespace-pre-line">
                  {item.discribed}
                </p>
              </div>
            ))}
          </div>
        </div>
      </BottomSheet>

      {isAuthenticated && isCongratsModalOpen && (
        <BabyCongratsModal
          week={pregnancyInfo.week}
          babyName={userInfo?.baby?.[0]?.baby_name}
          subtext={getCongratsData(pregnancyInfo.week, userInfo?.baby?.[0]?.baby_type)}
          onClose={() => setIsCongratsModalOpen(false)}
          onSave={() => {
            alert("축하 이미지가 저장되었습니다!");
          }}
          onShare={() => {
            alert("축하 이미지가 공유되었습니다!");
          }}
        />
      )}
    </>
  );
};

export default Main;
